<!-- src/views/pages/administration/reports/task-report-table.vue -->
<script setup>
import { computed, onMounted } from "vue";
import { useTaskStore } from "@/stores/taskStore";

const store = useTaskStore();

const columns = [
  { sorter: false },
  {
    title: "Task Name",
    dataIndex: "Task_Name",
    key: "Task_Name",
    sorter: {
      compare: (a, b) => {
        a = a.Task_Name.toLowerCase();
        b = b.Task_Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Project Name",
    dataIndex: "Project_Name",
    sorter: {
      compare: (a, b) => {
        a = a.Project_Name.toLowerCase();
        b = b.Project_Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Created Date",
    dataIndex: "Created_Date",
    sorter: {
      compare: (a, b) => {
        a = a.Created_Date.toLowerCase();
        b = b.Created_Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Due Date",
    dataIndex: "Due_Date",
    sorter: {
      compare: (a, b) => {
        a = a.Due_Date.toLowerCase();
        b = b.Due_Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Priority",
    dataIndex: "Priority",
    key: "Priority",
    sorter: {
      compare: (a, b) => {
        a = a.Priority.toLowerCase();
        b = b.Priority.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

const rows = computed(() =>
  store.items.map((t) => ({
    key: t.id,
    Task_Name: t.title,
    Project_Name: t.project_name || "-",
    Created_Date: t.created_pretty || "",
    Due_Date: t.due_pretty || "",
    Priority: t.priority || "",
    Status: t.status || "",
  }))
);

onMounted(() => {
  // For the report we want ALL filtered tasks, not paginated
  if (!store.items.length) {
    store.list({ paginate: false, page: 1, per_page: 5000 });
  }
});
</script>

<template>
  <a-table
    class="table datatable thead-light dq-report-table"
    :columns="columns"
    :data-source="rows"
    :row-selection="rowSelection"
    :loading="store.loading"
    :pagination="false"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Task_Name'">
        <div class="d-flex align-items-center file-name-icon">
          <h6 class="fw-medium">
            <a href="javascript:void(0);">{{ record.Task_Name }}</a>
          </h6>
        </div>
      </template>

      <template v-if="column.key === 'Priority'">
        <span
          class="badge"
          :class="[
            record.Priority === 'Low'
              ? 'badge-success-transparent'
              : record.Priority === 'Medium'
              ? 'badge-warning-transparent'
              : 'badge-danger-transparent',
          ]"
        >
          <i class="ti ti-point-filled me-1"></i>{{ record.Priority }}
        </span>
      </template>

      <template v-if="column.key === 'Status'">
        <span
          class="d-inline-flex align-items-center badge-xs"
          :class="[
            'badge',
            record.Status === 'Completed'
              ? 'badge-success'
              : record.Status === 'Inprogress'
              ? 'badge-purple'
              : record.Status === 'On Hold' || record.Status === 'Onhold'
              ? 'badge-warning'
              : 'badge-skyblue',
          ]"
        >
          <i class="ti ti-point-filled me-1"></i>{{ record.Status }}</span
        >
      </template>
    </template>
  </a-table>
</template>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-report-table .ant-table) {
    min-width: 920px;
  }

  :deep(.dq-report-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
